import { render } from "./SummaryDetails.vue?vue&type=template&id=b843f148&scoped=true"
import script from "./SummaryDetails.vue?vue&type=script&lang=js"
export * from "./SummaryDetails.vue?vue&type=script&lang=js"

import "./SummaryDetails.vue?vue&type=style&index=0&id=b843f148&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b843f148"]])

export default __exports__